export default [
  {
    path: '/modules/protocol',
    component: () => import('@/views/modules/protocol/Protocol.vue'),
    meta: {
      action: 'ROLE_PROTOCOLO_CONSULTAR',
      resource: 'ACL',
      pageTitle: 'Protocolo',
      breadcrumb: [
        {
          text: 'protocolo',
        },
      ],
    },
    children: [
      {
        path: '',
        name: 'protocol',
        component: () => import('@/views/modules/protocol/grid/ProtocolGrid.vue'),
        meta: {
          pageTitle: 'Protocolos',
          action: 'ROLE_PROTOCOLO_CONSULTAR',
          resource: 'ACL',
          breadcrumb: [
            {
              text: 'Módulo Protocolo | Protocolos',
            },
          ],
        },
      },
    ],
  },
]
